import axios from "axios";
import * as moment from "moment/moment";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { CreateUpdateOccupationalIllness, OccupationalIllness } from "./models";

const baseUrl = "/api/occupationalIllness";

const parseModel = (model: ServerModelWithDateStrings<OccupationalIllness>): OccupationalIllness => {
    return {
        ...model,
        firstDayOfAbsence: model.firstDayOfAbsence ? moment(model.firstDayOfAbsence) : undefined,
        lastDayOfAbsence: model.lastDayOfAbsence ? moment(model.lastDayOfAbsence) : undefined,
        dateCreated: model.dateCreated ? moment(model.dateCreated) : undefined,
        dateModified: model.dateModified ? moment(model.dateModified) : undefined,
        illnessStarted: model.illnessStarted ? moment(model.illnessStarted) : undefined,
        dateReportedToTheSheTeam: model.dateReportedToTheSheTeam ? moment(model.dateReportedToTheSheTeam) : undefined,
    };
};

const getAll = async (employeeRecordId: string) => {
    const data = (await axios.get<ServerModelWithDateStrings<OccupationalIllness>[]>(`${baseUrl}/${employeeRecordId}`)).data;
    return data.map(d => parseModel(d));
};

const get = async (id: string, employeeRecordId: string) => {
    const data = (await axios.get<ServerModelWithDateStrings<OccupationalIllness>>(`${baseUrl}/${employeeRecordId}/${id}`)).data;
    return parseModel(data);
};

const create = async (customerId: string, employeeRecordId: string, occupationalIllness: CreateUpdateOccupationalIllness): Promise<OccupationalIllness> => {
    return parseModel((await axios.post<
        ServerModelWithDateStrings<OccupationalIllness>
    >(`${baseUrl}/${customerId}/${employeeRecordId}`, occupationalIllness)).data);
};

const update = async (customerId: string, employeeRecordId: string, occupationalIllness: CreateUpdateOccupationalIllness): Promise<OccupationalIllness> => {
    return parseModel((await axios.put<
        ServerModelWithDateStrings<OccupationalIllness>
    >(`${baseUrl}/${customerId}/${employeeRecordId}/${occupationalIllness.id}`, occupationalIllness)).data);
};

const deleteOccupationalIllness = (id: string, employeeRecordId: string) => {
    return axios.delete(`${baseUrl}/${employeeRecordId}/${id}`);
};

export const OccupationalIllnessApi = { getAll, get, create, update, delete: deleteOccupationalIllness };
